<template>
	<div class="c-script-writer">
		<h3>Select script writer</h3>
		<div class="c-script-writer__buttons">
			<div
				v-for="option in computedOptions"
				:key="option.key"
				:class="[
					'c-script-writer__item',
					{ active: selected === option.value },
				]"
				@click="toggleSlug(option.value)"
			>
				<input
					type="radio"
					name="input-options"
					v-model="selected"
					:value="option.value"
				/>
				<label>
					<span class="dot"></span>

					<section>
						<header>
							<span v-html="option.icon"></span>
							<strong>
								{{ option.key }}
							</strong>
						</header>
						<p>
							{{ option.description }}
						</p>
						<ul v-if="option.uses">
							<li v-for="(use, i) in option.uses" :key="i">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M7 13L10 16L17 8"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								<span>
									{{ use }}
								</span>
							</li>
						</ul>
					</section>
				</label>
			</div>
		</div>
		<template v-if="selected && selected === 'VIDEO'">
			<strong> Additional info </strong>
			<FormVideoScript
				v-if="selected === 'VIDEO'"
				@onSubmit="onSubmit"
			></FormVideoScript>
		</template>
		<div class="text-center" v-else>
			<button
				type="button"
				:class="['btn btn-icon btn-box', { 'btn-primary': !!selected }]"
				@click="next"
			>
				<span v-if="processing" class="c-spinner"></span>
				<span> Next</span>
			</button>

			<article
				class="c-script-writer__credits article-text-sm"
				v-if="creditsUsed"
			>
				<p>Credits used: {{ creditsUsed }}</p>
			</article>
		</div>
	</div>
</template>

<script>
import scripts from '@swipekit/lib/scripts';
import FormVideoScript from '@swipekit/components/form/form-video-script';

export default {
	components: {
		FormVideoScript,
	},

	data: function () {
		return {
			otherText: '',
			selected: '',
			processing: false,
		};
	},

	props: {
		form: {},
	},

	computed: {
		computedOptions: function () {
			let options = scripts;
			return options;
		},
		creditsUsed: function () {
			if (!this.selected) {
				return;
			}

			if (this.selected === 'video') {
				return 4;
			}
			if (this.selected === 'copy') {
				return 1;
			}
		},
	},

	methods: {
		async next(meta) {
			if (!this.selected) {
				return;
			}
			this.processing = true;

			this.$emit('next', {
				type: this.selected,
				form: meta,
			});

			this.processing = false;
		},
		toggleSlug: function (key) {
			if (this.selected === key) {
				this.selected = null;
			} else {
				this.selected = key;
			}
		},
		slugify: function (str) {
			return str;
		},
		onChange: function (e) {
			let value = e.target.value;
			this.$emit('input', value);
		},
		onSubmit: function (meta) {
			console.log(meta);

			this.next(meta);
		},
	},

	mounted: function () {
		if (this.form.type) {
			this.selected = this.form.type;
		}
	},
};
</script>

<style lang="scss">
.c-script-writer {
	margin: 0 auto;
	width: var(--page-width);
	background-color: var(--color-bg-1);
	padding: 1rem;
	border-radius: 0.5rem;
	border: var(--color-bg-3) solid 1px;

	h3 {
		text-align: center;
		margin-bottom: 1rem;
	}

	&__buttons {
		display: flex;
		flex-direction: column;
		margin-bottom: 1rem;
	}

	&__item {
		display: flex;
		padding: var(--margin-lg);
		border-radius: var(--border-radius);
		cursor: pointer;

		cursor: pointer;

		user-select: none;

		input {
			display: none;
		}

		&:hover {
			background-color: var(--color-bg-3);
		}

		label {
			margin: 0;
			display: flex;
			font-size: var(--font-size);

			cursor: pointer;

			section {
				header {
					display: flex;
					align-items: center;
				}

				span {
					display: inline-block;
					height: 24px;
				}

				svg {
					margin-right: var(--margin);
				}

				strong {
					font-weight: 500;
				}

				p {
					font-size: var(--font-size-sm);

					&:last-of-type {
						margin-bottom: 0;
					}
				}

				ul {
					list-style: none;
					margin: 0;
					padding: 0;
					margin-top: 0.25rem;

					li {
						display: grid;
						grid-template-columns: 20px 1fr;
						grid-column-gap: var(--margin);
						align-items: flex-start;
						margin-bottom: 0;
						padding-left: 0;
						font-size: var(--font-size-xs);

						&:before {
							content: none;
						}

						span {
							height: initial;
						}

						svg {
							width: 20px;
							height: 20px;
						}
					}
				}
			}

			.dot {
				position: relative;
				width: 24px;
				min-width: 24px;
				height: 24px;
				border-radius: var(--border-radius-full);
				background-color: transparent;
				opacity: 0.5;
				margin-right: var(--margin);
				border: currentColor solid 2px;

				&:after {
					content: '';
					position: absolute;
					top: calc(50% - 4px);
					left: calc(50% - 4px);
					width: 8px;
					height: 8px;
					border-radius: var(--border-radius-full);
					background-color: currentColor;
					opacity: 0;
				}
			}

			> span {
				&:last-of-type {
					padding-top: 1px;
				}
			}

			article {
				padding-top: 2px;
				font-size: var(--font-size-xs);

				p {
					&:last-of-type {
						margin-bottom: 0;
					}
				}

				strong {
					font-weight: 500;
				}
			}
		}

		&.active {
			.dot {
				color: var(--color-primary);
				opacity: 1;

				&:after {
					opacity: 1;
				}
			}
		}
	}

	&__credits {
		margin-top: 0.5rem;
		font-size: var(--font-size-xs);
		font-weight: 500;
		font-family: var(--font-family-monospace);
	}

	.btn {
		width: 100%;
	}
}
</style>
